/**
 * Keep #VarN# placeholders visually intact under RTL (bidi).
 * Without isolation, #Var1# can render as ##Var1.
 */
export function isolateTemplateVariablePlaceholders(content: string): string {
    if (!content) {
        return '';
    }
    // U+2066 LEFT-TO-RIGHT ISOLATE, U+2069 POP DIRECTIONAL ISOLATE
    return content.replace(/#Var\d+#/gi, (match) => '\u2066' + match + '\u2069');
}
